import {
  setPageInfo,
} from '../../common/digitalDataBuilder';

import { Utils } from '../../site-bdc/common';
import { buildBcomAnalyticsEvent } from './commonAnalytics';

// TODO: delete this whole file and utilize the new GCC.NPM.AdobeAnalytics package

export const myEstimatesPageLoaded = () => {
  setPageInfo('my account>my estimates', 'my account');
};

export const howItWorksEstimatesModalLoaded = () => {
  Utils.sendAnalyticsEvent(buildBcomAnalyticsEvent('overlay', 'DIY estimate intro'));
};
